/**
 * 竞价区域汇总
 */
import React from 'react';

import { Row, Col, Tooltip, DatePicker, Select, Button } from 'antd';

import PageLayout from '../../ui/PageLayout';

import { fixedNumber, formatDate } from '../../../util/util';

//引入消息提示相关组件
import Loading from '../../ui/Loading';

import http from '../../../axios/http';



class AuctionAreaIndex extends React.Component {

    columns = [{
        title: '地区',
        dataIndex: 'channel',
        width: '10%',
        render: (value, row, index) => {
            return {
                children: value,
                props: {
                    rowSpan: row["rowSpan"] != null ? row["rowSpan"] : 0
                },
            };
        },
    }, {
        title: '门店',
        dataIndex: 'name',
        width: '15%',
    }, {
        title: '竞价台数',
        dataIndex: 'lotsNum',
        width: '10%',
    }, {
        title: '成交台数',
        dataIndex: 'dealNum',
        width: '10%',
    }, {
        title: '成交率',
        dataIndex: 'clientSource',
        width: '10%',
        render: (text, record, index) => {
            let val = record["lotsNum"];
            // eslint-disable-next-line eqeqeq
            if (val == null || val == "" || val == 0) {
                val = "0%";
            } else {
                val = fixedNumber(record["dealNum"] / record["lotsNum"] * 100, 2) + "%";
            }
            return (<Tooltip title={val} >{val}</Tooltip>)
        }
    }, {
        title: '溢价金额',
        dataIndex: 'premiumAmount',
        width: '10%',
    }, {
        title: '溢价率',
        dataIndex: 'premiumRate',
        width: '10%',
        render: (text, record, index) => {
            let val = text != null && text !== "" ? fixedNumber(text * 100, 2) + "%" : "";
            return (<Tooltip title={val} >{val}</Tooltip>)
        }
    }];

    state = {
        loadData: '',
        queryData: {
            channel: "",
            timeType: "day",
        },
        loadingVisible: false,

        countData: {},
    };

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        let timeType = queryData.timeType;
        if (dateStrings == null || dateStrings === "") {
            queryData.startDate = null;
            queryData.endDate = null;
        } else {
            if (timeType === "week") {
                let dates = dateStrings.split("-");
                let year = dates[0];
                let week = dates[1].replace("周", "");
                queryData.startDate = this.caclWeekDate(year, week, 1);
                queryData.endDate = this.caclWeekDate(year, week, 7);
            } else if (timeType === "month") {
                queryData.startDate = dateStrings + "-00";
                queryData.endDate = dateStrings + "-31";
            } else {
                queryData.startDate = dateStrings[0];
                queryData.endDate = dateStrings[1];
            }
        }

        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    selectChange = (field, data, e) => {
        let queryData = this.state.queryData;
        queryData[field] = data;
        this.setState({ queryData: queryData });
        if (field === "timeType") {
            queryData.startDate = null;
            queryData.endDate = null;
        }
        this.state.loadData(queryData);
    }

    /**
     * 获取某一年某一周的某一个星期
     * @param {年份} year 
     * @param {周数} week 
     * @param {周几} day  1-7,1代表周一
     * @returns 
     */
    caclWeekDate = (year, week, day) => {
        let date = new Date(year, 0, 1); //当前的第一天
        let dayMs = 86400000; //每天有几毫秒， 24 * 60 * 60 * 1000
        let firstDay = (7 - date.getDay()) * dayMs; //第一天的毫秒
        let weekMs = (week - 1) * 7 * dayMs; //
        let result = date.getTime() + firstDay + weekMs + day * dayMs;
        date.setTime(result);
        return formatDate(date);
    }

    download = () => {
        let queryData = this.state.queryData;
        this.setState({ loadingVisible: true });
        let fileName = "竞价汇总信息.xlsx";
        http.download({
            url: '/auctionSummaryArea/download',
            data: queryData,
            fileName: fileName,
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Select defaultValue="" onChange={this.selectChange.bind(this, "channel")} style={{ width: '150px' }}>
                                    <Select.Option value="">全部</Select.Option>
                                    <Select.Option value="建发汽车">建发汽车门店</Select.Option>
                                    <Select.Option value="非建发汽车">非建发汽车门店</Select.Option>
                                </Select>
                                <Select defaultValue="day" onChange={this.selectChange.bind(this, "timeType")} style={{ width: '150px', margin: "0 10px" }}>
                                    <Select.Option value="day">按日</Select.Option>
                                    <Select.Option value="week">按周</Select.Option>
                                    <Select.Option value="month">按月</Select.Option>
                                </Select>
                                {
                                    this.state.queryData.timeType === "week" ?
                                        <DatePicker.WeekPicker onChange={this.rangePickerChange} />
                                        : this.state.queryData.timeType === "month" ?
                                            <DatePicker.MonthPicker onChange={this.rangePickerChange} />
                                            : <DatePicker.RangePicker onChange={this.rangePickerChange} />
                                }

                                <Button type="primary" onClick={this.download} style={{ float: "right" }}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    page={false}
                    rowKey="clientSource"
                    url="/auctionSummaryArea/findSummaryArea"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <Loading visible={this.state.loadingVisible} message="处理中，请稍候..." />
            </div>
        )
    }

}

export default AuctionAreaIndex;